import { render, staticRenderFns } from "./PatrimoineDetailView.vue?vue&type=template&id=3083f43b&scoped=true&"
import script from "./PatrimoineDetailView.vue?vue&type=script&lang=js&"
export * from "./PatrimoineDetailView.vue?vue&type=script&lang=js&"
import style0 from "./PatrimoineDetailView.vue?vue&type=style&index=0&id=3083f43b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3083f43b",
  null
  
)

export default component.exports